import { FC } from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import styles from '@/styles/policy.module.css'
import RichTextContent from '@/templates/RichTextContent/RichTextContent'
import { number2Roman } from '@/utils/functions/number'
import { dateDDMMYYFormat } from '@/utils/functions/date'
import { useSideNavHighlight } from '@/hooks/useSideNavHighlight'

interface IProps {
  policy: PolicyPage
}
const Policy: FC<IProps> = ({ policy }) => {
  const { policyName, title, lastUpdated, description, policyMenu } = policy
  useSideNavHighlight(policyName)
  let sectionHash = 0
  let menuHash = 0

  return (
    <div className={clsx(styles.privacy_content)}>
      <div className={clsx('bg-privacy-banner', styles.banner)}>
        <strong>{policyName ?? ''}</strong>
      </div>
      <div className={clsx(styles.privacy_container)}>
        <nav className={clsx(styles.privacy_menu, 'sidebarNav')}>
          {policyMenu.length > 0 &&
            policyMenu.map((menu, menuIndex) => {
              menuHash += 1
              return (
                <div key={`menu_${menuIndex}`}>
                  {menu.title && (
                    <Link
                      href={`#section-${menuHash}`}
                      scroll={true}
                      className={styles.menu__item}
                    >
                      <strong>{menu.title}</strong>
                    </Link>
                  )}
                  {policyMenu[menuIndex].subContent.length > 0 &&
                    policyMenu[menuIndex].subContent.map(
                      (subMenu, subIndex) => {
                        menuHash += 1
                        return (
                          <div
                            key={`sub_menu_${subIndex}`}
                            className={styles.link_wrapper}
                          >
                            <Link
                              href={`#section-${menuHash}`}
                              scroll={true}
                              className={styles.menu__item}
                            >
                              {subMenu.title}
                            </Link>
                          </div>
                        )
                      }
                    )}
                </div>
              )
            })}
        </nav>
        <div className="privacy-body">
          <p className={styles.title}>
            <strong>{title ?? ''}</strong>
          </p>
          <p className={styles.date}>
            Last Updated : {dateDDMMYYFormat(lastUpdated) ?? ''}
          </p>
          <section className={styles.description_section}>
            <RichTextContent content={description} />
          </section>
          {policyMenu.length > 0 &&
            policyMenu.map((menu, menuIndex) => {
              sectionHash += 1
              return (
                <div key={`menu_${sectionHash}`}>
                  {menu.description && (
                    <section
                      id={`section-${sectionHash}`}
                      key={`menu_${sectionHash}`}
                      className={styles.description_section}
                    >
                      {menu.title && (
                        <h1 className={styles.sub_title}>{menu?.title}</h1>
                      )}
                      {menu.description && (
                        <RichTextContent content={menu?.description} />
                      )}
                    </section>
                  )}
                  {policyMenu[menuIndex].subContent.length > 0 &&
                    policyMenu[menuIndex].subContent.map(
                      (subMenu, subMenuIndex) => {
                        sectionHash += 1
                        return (
                          <section
                            key={`submenu_${sectionHash}`}
                            id={`section-${sectionHash}`}
                            className={styles.description_section}
                          >
                            <p className={styles.desc_para}>
                              <strong>
                                {number2Roman(subMenuIndex + 1)}.{' '}
                                {subMenu.title}
                              </strong>
                            </p>
                            <RichTextContent content={subMenu.description} />
                          </section>
                        )
                      }
                    )}
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default Policy
